import { number_from_query } from "@/api";
import { fetchUpdateHistory } from "@/api/updateHistory";
import { router } from "@/router/router";
import { useQuery } from "@tanstack/vue-query";
import { computed, ref, watch } from "vue";

interface UseUpdateHistoryParams {
  agent_id: string;
  campaign_id: string;
}

export const useUpdateHistory = (params: UseUpdateHistoryParams) => {
  const page = ref(number_from_query("page", 1));
  const size = ref(number_from_query("size", 12));

  watch(
    () => [router.currentRoute.value.query],
    () => {
      page.value = number_from_query("page", 1);
      size.value = number_from_query("size", 12);
    },
  );

  const { data, isLoading, error } = useQuery({
    queryKey: ["updateHistory", params, page, size],
    queryFn: () =>
      fetchUpdateHistory({
        agent_id: params.agent_id,
        campaign_id: params.campaign_id,
        page: page.value,
        size: size.value,
      }),
    staleTime: 5 * 60 * 1000,
  });

  const updateHistory = computed(() => data?.value?.data || []);
  const total_filter = computed(() => data?.value?.total_filter || 0);
  const total_page = computed(() =>
    Math.ceil((data?.value?.total_filter || 0) / size.value),
  );

  return {
    updateHistory,
    total_filter,
    total_page,
    isLoading,
    error,
  };
};
